(function () {
  class MovieSymbolAnimator extends PIXI.Container {
    constructor() {
      super();
      this.visible = false;
      this._trackInfo = undefined;
      this._bgMovie = undefined;
      this._overlay = undefined;
      Reflex.registerEventHandler('orientationChange', this.onOrientationChange.bind(this));
    }

    play(trackInfo, loop, onCellAnimFinishedCb) {
      this._trackInfo = trackInfo;
      this.initialiseSymbolMovie(trackInfo.getPosition(), trackInfo.reelId);
      trackInfo.showSymbol(false);

      let symbolId = trackInfo.symbolId;
      if (symbolId >= 11 && symbolId <= 14) {
        let frameIndex = symbolId - 11;
        this._overlay.visible = true;
        this._overlay.gotoAndPlay(frameIndex);
        // Ensure overlay position is correct after being made visible
        if (this._overlayYOffset !== undefined) {
          this._overlay.position.y = this._overlayYOffset;
        }
      }

      const self = this;

      if (gameController.inFreeSpins && this._fsmovie !== undefined) {
        const self = this;
        this._fsmovie.onComplete = function () {
          self._fsmovie.visible = false;
          self._overlay.visible = false;
          onCellAnimFinishedCb(self);
        };
        this._fsmovie.visible = true;
        this._fsmovie.gotoAndPlay(0);
      } else {
        this._movie.onComplete = function () {
          self._overlay.visible = false;
          onCellAnimFinishedCb(self);
        };
        this._movie.gotoAndPlay(0);
      }
      if (this._bgMovie !== undefined) {
        this._bgMovie.gotoAndPlay(0);
      }
    }

    initialiseSymbolMovie(symPos, reelId) {
      this.visible = true;
      this._movie.gotoAndStop(0);
      if (this._bgMovie !== undefined) {
        this._bgMovie.gotoAndStop(0);
      }
      if (this._fsmovie !== undefined) {
        this._fsmovie.gotoAndStop(0);
      }

      const isNudge = this.isNudgeAnimation();

      // Apply per-reel Y adjustment only for nudge animations on adjusted reels
      let yAdjustment = 0;
      if (
        isNudge &&
        reelId !== undefined &&
        gameController.nudgeAnimationYAdjustment &&
        gameController.nudgeAnimationYAdjustment[reelId]
      ) {
        yAdjustment = gameController.nudgeAnimationYAdjustment[reelId];
      }

      this.position.set(symPos.x + this._positionOffset.x, symPos.y + this._positionOffset.y + yAdjustment);

      // Apply masking for nudge reel animations to prevent oversized symbols from appearing between reels
      if (isNudge && gameController.animationMaskPool) {
        // Get an available mask from the pool to avoid memory issues
        if (!this._pooledMask) {
          this._pooledMask = this.getAvailableMaskFromPool();
          if (this._pooledMask) {
            this._maskContainer = new PIXI.Container();
            this._maskContainer.renderable = false; // Prevent container from rendering. This was causing the white square issue.
            this.addChild(this._maskContainer);
            this._maskContainer.addChild(this._pooledMask);
            this._maskContainer.position.set(-this._positionOffset.x, -this._positionOffset.y);
          }
        }

        // Apply the pooled mask to the movie sprites
        if (this._pooledMask) {
          this._movie.mask = this._pooledMask;
          if (this._bgMovie) this._bgMovie.mask = this._pooledMask;
          if (this._fsmovie) this._fsmovie.mask = this._pooledMask;
          if (this._overlay) this._overlay.mask = this._pooledMask;
        }
      }
    }

    getAvailableMaskFromPool() {
      // Find an unused mask from the pool
      for (let i = 0; i < gameController.animationMaskPool.length; i++) {
        const mask = gameController.animationMaskPool[i];
        if (!mask._isInUse) {
          mask._isInUse = true;
          return mask;
        }
      }
      return null; // No available masks
    }

    returnMaskToPool() {
      // Return the mask to the pool when animation is finished
      if (this._pooledMask) {
        this._pooledMask._isInUse = false;
        if (this._maskContainer) {
          this._maskContainer.removeChild(this._pooledMask);
          this.removeChild(this._maskContainer);
        }
        this._pooledMask = null;
        this._maskContainer = null;
      }
    }

    isNudgeAnimation() {
      // Check if this animator is within the nudge animation container by checking parent hierarchy
      let parent = this.parent;
      while (parent) {
        if (
          parent.name === 'nudgeAnimationContainer' ||
          parent.name === 'SymbolAnimator' ||
          (parent.parent && parent.parent.name === 'nudgeSlotContainer')
        ) {
          return true;
        }
        parent = parent.parent;
      }
      return false;
    }

    getTrackInfo() {
      return this._trackInfo;
    }

    finalise() {
      this.visible = false;
      this._trackInfo.showSymbol(true);
      this._trackInfo = undefined;
      // Return mask to pool when animation is finished
      this.returnMaskToPool();
    }

    untrack() {
      if (this._trackInfo) {
        this._trackInfo.untrack();
      }
    }

    skip() {
      this.untrack();
    }

    onOrientationChange() {
      if (this._trackInfo !== undefined) {
        let symPos = this._trackInfo.getPosition();

        // Apply per-reel Y adjustment only for nudge animations on adjusted reels
        let yAdjustment = 0;
        const reelId = this._trackInfo.reelId;
        const isNudge = this.isNudgeAnimation();
        if (
          isNudge &&
          reelId !== undefined &&
          gameController.nudgeAnimationYAdjustment &&
          gameController.nudgeAnimationYAdjustment[reelId]
        ) {
          yAdjustment = gameController.nudgeAnimationYAdjustment[reelId];
        }

        this.position.set(symPos.x + this._positionOffset.x, symPos.y + this._positionOffset.y + yAdjustment);
      }
    }
  }

  let create = function () {
    return new MovieSymbolAnimator();
  };

  let initialise = function (json, instance) {
    if (json.playData.includeBgAnim) {
      instance._bgMovie = resourceManager.createObject('movie', 'bgAnim', instance.name, {
        definition: 'Symbol_BgWin',
      });
      instance._bgMovie.loop = 0;
      instance._bgMovie.gotoAndStop();
      instance._bgMovie.anchor.set(0.5);
    }
    instance._movie = resourceManager.createObject('movie', json.playData.definition, instance.name, {
      definition: json.playData.definition,
    });
    instance._movie.loop = false;
    instance._movie.gotoAndStop(0);
    instance._movie.anchor.set(0.5);
    if (json.playData.fsDefinition !== undefined) {
      instance._fsmovie = resourceManager.createObject('movie', json.playData.fsDefinition, instance.name, {
        definition: json.playData.fsDefinition,
      });
      instance._fsmovie.loop = false;
      instance._fsmovie.gotoAndStop(0);
      instance._fsmovie.anchor.set(0.5);
      instance._fsmovie.visible = false;
    }

    instance._positionOffset = { x: 0, y: 0 };
    if (json.playData.posOffset) {
      instance._positionOffset = json.playData.posOffset;
    }

    instance._overlay = resourceManager.createObject('movie', 'overlay', instance.name, {
      definition: 'multipliers',
    });
    instance._overlay.loop = false;
    instance._overlay.gotoAndStop(0);
    instance._overlay.anchor.set(0.5);
    instance._overlay.visible = false;
    instance._overlayYOffset = 50;
    instance._overlay.position.y = instance._overlayYOffset;

    // Ensure overlay is a direct child of this container
    instance.addChild(instance._overlay);
  };

  let getRequiredFiles = function () {
    return [];
  };

  resourceManager.registerObjectType('movieSymbolAnimator', create, initialise, getRequiredFiles);
})();
